"use client";

import { useHexStatsStatus } from "@/hooks/use-hexstats";
import { useHexPrices } from "@/hooks/use-hex-prices";

export function DashboardStats() {
  const { data, isLoading } = useHexStatsStatus();
  const { data: prices, isLoading: pricesLoading } = useHexPrices();

  const stats = [
    {
      label: "Current Day",
      value: data?.lastPulsechainDay ? `Day ${data.lastPulsechainDay}` : "—",
    },
    {
      label: "eHEX Price",
      value: prices?.ehexFormatted ?? "—",
    },
    {
      label: "pHEX Price",
      value: prices?.phexFormatted ?? "—",
    },
  ];

  const loading = isLoading || pricesLoading;

  return (
    <div className="mb-8 grid grid-cols-1 gap-3 sm:grid-cols-3 lg:gap-4">
      {stats.map(({ label, value }) => (
        <div key={label} className="lhx-card px-5 py-4">
          <p className="label-caps">{label}</p>
          <p className="stat-value mt-1">
            {loading ? (
              <span className="inline-block h-8 w-28 animate-pulse rounded bg-surface-400" />
            ) : (
              value
            )}
          </p>
        </div>
      ))}
    </div>
  );
}

export default DashboardStats;
